module.exports = ".error-panel {\n  min-height: 27px;\n  margin-left: -11px;\n  margin-right: -11px;\n  padding-left: 12px;\n  border: 1px solid red;\n}\n"